import { CAMPAIGNS_API } from 'modules/campaigns/api/constants'
import { CampaignApiInterface } from 'modules/campaigns/types/campaign-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { baseFetcher } from 'shared/utils/http-client'

interface UseCampaignsInterface extends SwrPaginationInterface {}

export function useCampaigns({ limit, pagination }: UseCampaignsInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CampaignApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: campaigns, mutate } = useControlledSwr(
    () => [
      `${CAMPAIGNS_API}/list?${getPaginationQueryString({ limit, pagination })}`,
      RequestModuleEnum.Campaign,
      RequestModuleEnum.CampaignStep,
    ],
    fetcher,
    undefined,
    !!user,
  )

  const { data: counter } = useControlledSwr(() => {
    if (user) {
      return [`${CAMPAIGNS_API}/count?pagination[limit]`, RequestModuleEnum.Campaign]
    }
    return null
  }, baseFetcher)

  return { campaigns, mutate, counter }
}
